
import React, { useState, useEffect } from 'react'

// TODO: update on resize, scroll, etc
// TODO: add auto-positioning
// TODO: fix weird jitter, window width?

/**
 * Positioner component.
 */

export default function Positioner({ trigger, popover, position = 'top', offset = 8, offsetX = 0, offsetY = 0, children }) {
  const [style, setStyle] = useState(null)
  
  useEffect(_ => {
    const pos = getAutoPosition({ trigger, popover, position, offset })
    pos.left += offsetX
    pos.top += offsetY
    setStyle({ position: 'absolute', ...pos })
  }, [])

  return children({ style })
}

/**
 * getAutoPosition returns the auto-position, keeping the popover within view.
 */

function getAutoPosition({ trigger, popover, position, offset }) {
  const pos = getPosition({ trigger, popover, position, offset })
  const pe = popover.current
  const pr = pe.getBoundingClientRect()
  const wh = window.innerHeight
  const kind = position.split(' ')
  
  // too low
  if (kind[0] == 'bottom' && (pos.top + pr.height) > wh) {
    position = kind.length == 2
      ? `top ${kind[1]}`
      : 'top'
    return getPosition({ position, trigger, popover, offset })
  }

  return pos
}

/**
 * getPosition returns the requested position for popover relative to the trigger element.
 */

function getPosition({ trigger, popover, position, offset }) {
  const te = trigger.current
  const pe = popover.current
  const tr = te.getBoundingClientRect()

  switch (position) {
    case 'top':
      return {
        top: tr.top - pe.offsetHeight - offset,
        left: tr.left + (te.offsetWidth / 2) - (pe.offsetWidth / 2)
      }
    case 'top right':
      return {
        top: tr.top - pe.offsetHeight - offset,
        left: tr.left - (pe.offsetWidth - te.offsetWidth)
      }
    case 'right':
      return {
        top: tr.top - (pe.offsetHeight / 2) + (te.offsetHeight / 2),
        left: tr.left + te.offsetWidth + offset
      }
    case 'bottom right':
      return {
        top: tr.top + te.offsetHeight + offset,
        left: tr.left - (pe.offsetWidth - te.offsetWidth)
      }
    case 'bottom':
      return {
        top: tr.top + te.offsetHeight + offset,
        left: tr.left + (te.offsetWidth / 2) - (pe.offsetWidth / 2)
      }
    case 'bottom left':
      return {
        top: tr.top + te.offsetHeight + offset,
        left: tr.left
      }
    case 'left':
      return {
        top: tr.top - (pe.offsetHeight / 2) + (te.offsetHeight / 2),
        left: tr.left - pe.offsetWidth - offset
      }
    case 'top left':
      return {
        top: tr.top - pe.offsetHeight - offset,
        left: tr.left
      }
    default:
      throw new Error(`invalid position '${position}'`)
  }
}